<kodit-table *ngIf="!isEmpty" [tableConfig]="tableConfig" [paginatedData]="paginatedData"></kodit-table>
